export default __webpack_public_path__ + "static/media/calendar-1.89bf6b79.svg";